







































































import { Component, Vue } from 'vue-property-decorator';
import { dictServe, performanceServer, regionServe } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';
import { TableStripe } from '@/mixins/tableStripe';
import publishObjectPath from '@/util/configRegistry';

@Component({
  components: {},
  mixins: [TableStripe],
})
export default class EditHazardDialog extends Vue {
  private visible = false;
  private hiddenForm: any = {
    hazardContent: '',
    hazardLevel: '',
    hazardType: '',
    hazardTypeLabel: '',
    rectifySuggestion: '',
    taskId: '',
    hazardDiscoverDate: '',
    itemId: '',
    areaId: '',
    hazardPicture: '',
    groupHazardCategoryCode: '',
    groupHazardCategoryLabel: '',
  };
  private hazardContent: any = '';

  private hiddenFormRules = {
    groupHazardCategoryCode: [{ required: true, message: '请选择问题分类', trigger: 'blur' }],
    hazardType: [{ required: true, message: '请选择隐患分类', trigger: 'blur' }],
    hazardDiscoverDate: [{ required: true, message: '请选择上报时间', trigger: 'blur' }],
    hazardLevel: [{ required: true, message: '请选择隐患级别', trigger: 'blur' }],
    hazardContent: [{ required: true, message: '请输入隐患内容', trigger: 'blur' }],
    rectifySuggestion: [{ required: true, message: '请输入整改建议', trigger: 'blur' }],
  };

  private hazardTypeList: any = [];
  private hazardLevelList: any = [];
  private spaceAreaList: any = [];
  private checkItemsList: any = [];

  private fileList: any = [];
  private actionUrl: any = '';
  private headers: any = {};
  private serverUrl = publishObjectPath.imgPathWater;

  private id: any = ''; // 隐患id
  private groupHazardCategoryList: any = [];

  mounted() {
    this.actionUrl = publishObjectPath.serverUrl + '/api/sysManage/sysFile/annex';
    this.headers.Authorization = localStorage.getItem('token');
  }

  showDialog(data: any, id: any) {
    this.checkItemsList = data;
    this.id = id;
    this.getHazardTypeList();
    this.getHazardLevelList();
    this.getSpaceAreaData();
    this.getHazardInfo();
    this.getGroupHazardCategoryList(); // 隐患级别
    this.visible = true;
  }

  private getHazardInfo() {
    performanceServer.infoSecurityCheckHazard(this.id).then((res: any) => {
      if (res.code === '200') {
        this.hiddenForm.hazardType = res.data.hazardType;
        this.hiddenForm.hazardTypeLabel = res.data.hazardTypeLabel;
        this.hiddenForm.hazardDiscoverDate = res.data.hazardDiscoverDate;
        this.hiddenForm.hazardLevel = res.data.hazardLevel;
        this.hiddenForm.areaId = res.data.areaId;
        this.hiddenForm.hazardContent = res.data.hazardContent;
        this.hazardContent = res.data.hazardContent;
        this.hiddenForm.rectifySuggestion = res.data.rectifySuggestion;
        this.hiddenForm.hazardPicture = res.data.hazardPicture;
        this.hiddenForm.itemId = res.data.itemId;
        this.hiddenForm.taskId = res.data.taskId;
        this.hiddenForm.groupHazardCategoryCode = res.data.groupHazardCategoryCode;
        this.hiddenForm.groupHazardCategoryLabel = res.data.groupHazardCategoryLabel;

        this.$nextTick(() => {
          this.checkItemsList.map((item: any) => {
            if (res.data.itemId === item.id) {
              (this.$refs.multipleTable as any).toggleRowSelection(item, true);
            }
          });
        });
        if (res.data.hazardPictureFiles && res.data.hazardPictureFiles.length) {
          this.fileList = res.data.hazardPictureFiles.map((item: any) => {
            return {
              ...item,
              url: publishObjectPath.imgPathWater + item.path,
            };
          });
        }
      }
    });
  }
  tableChange(selection: any, row?: any) {
    (this.$refs.multipleTable as any).clearSelection();
    const selected = selection.length && selection.indexOf(row) !== -1; //为true时选中，为 0 时（false）未选中
    if (selected) {
      (this.$refs.multipleTable as any).toggleRowSelection(row, true);
      this.hiddenForm.itemId = row.id;
      if (row.other) {
        const str: any = JSON.parse(row.other);
        this.hiddenForm.hazardContent = str.riskControlRunawayShow ? str.riskControlRunawayShow : '';
      } else {
        this.hiddenForm.hazardContent = this.hazardContent;
      }
    } else {
      this.hiddenForm.hazardContent = this.hazardContent;
      this.hiddenForm.itemId = '';
    }
  }

  getGroupHazardCategoryList() {
    dictServe.getDetailsMapByName('groupHazardCategory').then((res: any) => {
      if (res.code === '200') {
        const dictData: any = [];
        for (const key in res.data) {
          dictData.push({
            value: key,
            label: res.data[key],
          });
        }
        this.groupHazardCategoryList = dictData;
      } else {
        this.$message.warning('获取隐患等级的列表数据失败！');
      }
    });
  }

  private handleSuccess(response: any, file: any, fileList: any) {
    const arr: any = [];
    // console.log(fileList, 'fileList');
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.hiddenForm.hazardPicture = arr.toString(); // 存放选择的隐患图片
  }

  private handleRemove(file: any, fileList: any) {
    const arr: any = [];
    fileList.forEach((item: any) => {
      if (item.response && item.response.data) {
        arr.push(item.response.data[0].id);
      } else {
        arr.push(item.id);
      }
    });
    this.hiddenForm.hazardPicture = arr.toString(); // 存放选择的隐患图片
  }
  // 获取隐患类型的列表
  async getHazardTypeList() {
    const res: any = await performanceServer.customRelevanceData({
      type: 'hazardClassify',
    });
    if (res.code === '200') {
      res.data.forEach((item: any) => {
        this.callbackHazardTypeList(item);
      });
      this.hazardTypeList = res.data;
    } else {
      this.$message.warning('获取隐患类型的数据失败！');
    }
  }
  private callbackHazardTypeList(data: any) {
    if (data.children.length) {
      data.children.forEach((item: any) => {
        this.callbackHazardTypeList(item);
      });
    }
    if (!data.children.length) {
      delete data.children;
    }
  }
  // 获取隐患等级的列表
  getHazardLevelList() {
    dictServe.getDetailsMapByName('securityCheckHazardLevel').then((res: any) => {
      if (res.code === '200') {
        const dictData: any = [];
        for (const key in res.data) {
          dictData.push({
            value: key,
            label: res.data[key],
          });
        }
        this.hazardLevelList = dictData;
      } else {
        this.$message.warning('获取隐患等级的列表数据失败！');
      }
    });
  }
  // 获取区域列表
  getSpaceAreaData() {
    regionServe.getRegionAllData({}).then((res: any) => {
      if (res.code === '200') {
        this.spaceAreaList = arrayToTree(res.data);
      } else {
        this.$message.warning('获取区域的列表失败！');
      }
    });
  }

  hideDialog() {
    (this.$refs.formRef as any).resetFields(); // 重置表单内容
    this.fileList = [];
    this.hazardContent = '';
    this.$emit('hideDialog');
    this.visible = false;
  }

  submitForm() {
    //表单验证
    const formComponent: any = this.$refs['formRef'];
    formComponent.validate(async (valid: any) => {
      if (!valid) return;
      const arr: any = (this.$refs.hazardTypeRef as any).getCheckedNodes();
      if (!arr[0]) {
        this.hiddenForm.hazardTypeLabel = '';
      } else {
        this.hiddenForm.hazardTypeLabel = arr[0].label;
      }
      if (this.hiddenForm.groupHazardCategoryCode) {
        const findData: any = this.groupHazardCategoryList.find((item: any) => item.value === this.hiddenForm.groupHazardCategoryCode);
        this.hiddenForm.groupHazardCategoryLabel = findData.label;
      } else {
        this.hiddenForm.groupHazardCategoryLabel = '';
      }
      this.editHazardFun();
    });
  }
  editHazardFun() {
    performanceServer.editSecurityCheckHazard(this.id, this.hiddenForm).then((res: any) => {
      if (res.code === '200') {
        this.$message.success('编辑成功！');
        this.hideDialog();
      } else {
        this.$message.warning(res.msg);
      }
    });
  }
}
